<template>
  <div class="orders-filters" data-testid="orders-filters">
    <template v-if="isLoading">
      <SkeletonLoader
        v-if="isLoading"
        show-animation
        data-testid="orders-filters-loader"
        class="orders-filters__loader"
      >
        <div class="orders-filters__loader__filter" />
        <div class="orders-filters__loader__date" />
      </SkeletonLoader>
    </template>
    <template v-else>
      <FilterSelect
        class="orders-filters__filter"
        data-testid="orders-filters-type"
        :value="filters[OrdersFiltersKeys.Type].value"
        :options="filters[OrdersFiltersKeys.Type].options"
        label="Tipo"
        use-option-label
        :disabled="!hasFilters"
        render-menu-with-portal
        @change="value => emitOnFilterSelection(OrdersFiltersKeys.Type, value)"
      />
      <BaseText
        v-if="updatedAt"
        class="orders-filters__date"
        size="xs"
        :color="NebraskaColors.elementSecondary"
        >{{ updatedAt }}</BaseText
      >
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import {
  BaseText,
  SkeletonLoader,
  FilterSelect
} from '@warrenbrasil/nebraska-web';

import {
  OrdersFiltersKeys,
  IOrdersFilters
} from '@/modules/wealth/views/IndexPortfolio/components/Orders/types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  filters: IOrdersFilters;
  isLoading: boolean;
  updatedAt?: string;
}
const props = defineProps<Props>();

interface Emit {
  (
    event: 'on-filter-selection',
    filterKey: OrdersFiltersKeys,
    value: string
  ): void;
}
const emit = defineEmits<Emit>();

const hasFilters = computed(() => {
  const filtersKeys = Object.values(OrdersFiltersKeys);

  return filtersKeys.some(filterKey => {
    return !!props.filters[filterKey].options?.length;
  });
});

const emitOnFilterSelection = (filterKey: OrdersFiltersKeys, value: string) => {
  emit('on-filter-selection', filterKey, value);
};
</script>

<style lang="less" scoped>
.orders-filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  &__filter {
    margin-bottom: @size-spacing-x300;

    &:not(:last-of-type) {
      margin-right: @size-spacing-x300;
    }
  }

  &__date {
    margin-bottom: @size-spacing-x300;
    margin-left: @size-spacing-x300;
  }

  &__loader {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    &__filter {
      &:not(:last-of-type) {
        margin-right: @size-spacing-x300;
      }

      width: 100px;
      height: 32px;
      border-radius: @size-radius-max;
      margin-right: @size-spacing-x300;
      margin-bottom: @size-spacing-x300;
    }

    &__date {
      margin-bottom: @size-spacing-x300;
      margin-left: @size-spacing-x300;
      width: 130px;
      height: 18px;
      border-radius: @size-radius-x100;
    }
  }
}
</style>
